var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMuteVolume = function SvgMuteVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "mute-volume_svg__Layer_1",
    width: 20,
    height: 20,
    strokeWidth: 1.5,
    color: "#24053b",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    role: "presentation"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5e2-1{fill:none;stroke:currentColor;stroke-miterlimit:10}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 9.14-5.73 5.72M16.77 9.14l5.73 5.72M1.5 8.18h4.77v7.64H1.5zM13.91 3.41v17.18h-1.67l-5.97-4.77V8.18l5.97-4.77z",
    className: "cls-6374f543b67f094e4896c5e2-1"
  })));
};
export default SvgMuteVolume;